import { AppViewStore } from '@planning/stores/AppViewStore'
import { shouldShowLoadingIndicator } from '@tom-ui/utils'
import { AxiosError, AxiosResponse } from 'axios'

export const onFulfilled = (appStore: AppViewStore) => {
  return (response: AxiosResponse<any>) => {
    if (shouldShowLoadingIndicator(window.location.pathname, response.config.url)) {
      appStore.hideLoader()
    }

    return response
  }
}

export const onRejected = (appStore: AppViewStore) => {
  return (error: AxiosError) => {
    if (shouldShowLoadingIndicator(window.location.pathname, error.config?.url)) {
      appStore.hideLoader()
    }

    throw error
  }
}
